import { createSvgIcon } from '@automata/mui-theme';
export const ShakeIcon = createSvgIcon(
  <svg viewBox="0 0 96 96" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M42.8125 19V29.919C42.8125 30.7248 42.7043 31.527 42.4907 32.304L31.5977 71.94C30.8979 74.4863 32.814 77 35.4547 77H60.531C63.1718 77 65.0878 74.4863 64.388 71.94L53.4958 32.3068C53.2822 31.5298 53.174 30.7276 53.174 29.9218V19H42.8125ZM39.8125 18.3408C39.8125 17.048 40.8605 16 42.1533 16H53.8332C55.126 16 56.174 17.048 56.174 18.3408V29.9218C56.174 30.459 56.2462 30.9938 56.3885 31.5118L67.2808 71.145C68.5054 75.6011 65.1523 80 60.531 80H35.4547C30.8334 80 27.4803 75.6011 28.705 71.145L39.598 31.509C39.7404 30.991 39.8125 30.4562 39.8125 29.919V18.3408Z"
    />
    <path d="M30.0507 69.2129H65.9976V77.1401H30.0507V69.2129Z" />
    <path d="M32.0475 62.2766H64.0003V70.2038H32.0475V62.2766Z" />
    <path d="M37.0402 42.4586H49.0225V45.4313H37.0402V42.4586Z" />
    <path d="M36.0416 50.3858H49.0225V53.3585H36.0416V50.3858Z" />
    <path d="M16 38H19V54H16V38Z" />
    <path d="M80 38H77V54H80V38Z" />
    <path d="M23 35H26V57H23V35Z" />
    <path d="M73 35H70V57H73V35Z" />
  </svg>,
  'ShakeIcon'
);
